import { ActionFromReducer, combineReducers } from 'redux';

import { authReducer } from './auth/reducer';
import { configReducer } from './config/reducer';
import { lluReducer } from './llu/reducer';
import { modalReducer } from './modal/reducer';
import { navReducer } from './nav/reducer';
import { partnerReducer } from './partner/reducer';
import { practiceReducer } from './practice/reducer';
import { userReducer } from './user/reducer';

const reducerMap = {
  auth: authReducer,
  config: configReducer,
  llu: lluReducer,
  modal: modalReducer,
  nav: navReducer,
  partner: partnerReducer,
  practice: practiceReducer,
  user: userReducer,
};

export const rootReducer = combineReducers(reducerMap);

export type RootState = ReturnType<typeof rootReducer>;

export type RootActions = ActionFromReducer<typeof rootReducer>;
